// extracted by mini-css-extract-plugin
export var orderDetails = "_ru-2";
export var orderImage = "_ru-1";
export var orderMeta = "_ru-3";
export var orderSummary = "_ru-0";
export var rightArrow = "_ru-4";